export enum Page {
    PARTNERS_PAGE = 'partnersPage',
}
